module.exports = __webpack_public_path__ + "static/media/contact-page-background.c6ce1c27.svg";